// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import I18n from "../../i18n/I18n";
import Helper from "../../helper/Helper";
import _ from "lodash";
import { Dropdown, Button, Icon, Modal, ToggleButton, Loader } from "../common";
import { AsnTable } from "../transfers/index";
import styles from "./PreviewImports.scss";
import ImportProducts from "../products/importProducts/ImportProducts";

class PreviewStock extends Component {
  state = {
    modalOpen: false,
    importError: "",
    importSuccess: "",
    lines: []
  };

  openModal = () => {
    this.setState({
      modalOpen: true
    });
  };

  onCloseModal = () => {
    this.setState({
      modalOpen: false,
      importError: "",
      importSuccess: ""
    });
  };

  componentDidMount = () => {
    if (this.props.batches && !_.isEmpty(this.props.batches)) {
      this.props.toggleBatch(this.props.batches[0].id_partner_document);
    }
    if (this.props.initialLines && !this.props.isInitialLoading) {
      const { lines } = this.state;
      const newLines = lines.concat(this.props.initialLines);
      this.setState({
        lines: newLines
      });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.importedBatch &&
      this.props.importedBatch !== prevProps.importedBatch
    ) {
      this.props.toggleBatch(this.props.importedBatch);
    }

    // if (this.props.currentBatch !== prevProps.currentBatch) {
    //   this.setState({
    //     lines: []
    //   });
    // }

    if (!_.isEqual(this.props.initialLines, prevProps.initialLines)) {
      const { lines } = this.state;
      const newLines =
        this.props.scrollPage === 1
          ? this.props.initialLines
          : lines.concat(this.props.initialLines);

      this.setState({
        lines: newLines
      });
    }
  };

  importStock = file => {
    if (file) {
      this.props.importStock(file);
      this.onCloseModal();
    }
  };

  render() {
    const {
      batches,
      initialLines,
      browser,
      importStock,
      exportPSku,
      toggleBatch,
      currentBatch,
      scrollPage,
      loadFunc,
      noOfPages,
      isImporting,
      isInitialLoading,
      importsType
    } = this.props;

    const batchesList =
      batches && !_.isEmpty(batches)
        ? batches.map((batch, index) => {
            const duration = batch.created_at
              ? moment.duration(moment().diff(batch.created_at))
              : "";

            let val = moment(batch.created_at).format("MMM DD");
            const hours = duration && duration.asHours();
            if (Number(hours) < 24) {
              val = I18n.getText("notification.hrs-ago", {
                hours: Math.round(Number(hours))
              });
            }
            if (Number(hours) < 1) {
              const minutes = duration && duration.asMinutes();
              val = I18n.getText("notification.minutes-ago", {
                minutes: Math.round(Number(minutes))
              });
            }

            return (
              <div
                className={`${styles.eachBatch} ${
                  currentBatch === batch.id_partner_document
                    ? styles.selected
                    : ""
                }`}
                onClick={() => toggleBatch(batch.id_partner_document)}
              >
                <div className={styles.name}>
                  <div>
                    {`${batch.name}`}{" "}
                    {currentBatch === batch.id_partner_document ? (
                      <Icon
                        name="loop"
                        className={
                          isImporting &&
                          currentBatch === batch.id_partner_document
                            ? styles.loading
                            : ""
                        }
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className={styles.date}>{val}</div>
                </div>
                <div>
                  <div className={styles.count}>{batch.count}</div>
                </div>
              </div>
            );
          })
        : "";

    const linesList =
      this.state.lines && !_.isEmpty(this.state.lines) ? (
        <AsnTable
          data={this.state.lines}
          view={"grid"}
          browser={browser}
          lang={Helper.getLang()}
          loadFunc={loadFunc}
          scroll
          scrollLoading={scrollPage && noOfPages && scrollPage < noOfPages}
          imports
          importsType={importsType}
        />
      ) : (
        <div className={styles.blankBtn}>
          {isImporting && scrollPage === 1 ? (
            <Loader style={{ height: "unset" }} />
          ) : (
            <div>
              {batches && !_.isEmpty(batches) ? (
                <div>
                  <div className={styles.importTxt}>
                    {I18n.getText("transfers.nothing-to-show")}
                  </div>
                </div>
              ) : (
                <div>
                  <div className={styles.importTxt}>
                    {I18n.getText("import.import-stock")}
                  </div>
                  <Button
                    className={styles.printCtr}
                    onClick={() => this.openModal()}
                  >
                    <Icon name="stack" className={styles.printIcon} />
                    {isImporting ? (
                      <div className={styles.loader} />
                    ) : (
                      I18n.getText("import.import-stock")
                    )}
                  </Button>
                </div>
              )}
            </div>
          )}
        </div>
      );

    return (
      <div className={styles.ctr}>
        <div className={styles.flexView}>
          {batches &&
            !_.isEmpty(batches) && (
              <div className={styles.side}>
                <Button
                  className={`${styles.printCtr} ${styles.batchBtn}`}
                  onClick={() => this.openModal("new")}
                  variant="transparent"
                >
                  <Icon name="plus" className={styles.printIcon} />
                  {I18n.getText("import.import-stock")}
                </Button>
                {batchesList}
              </div>
            )}
          <div className={styles.linesCtr}>{linesList}</div>
        </div>
        <Modal
          contentLabel={"ProductImport"}
          isOpen={this.state.modalOpen}
          closeModal={() => this.onCloseModal()}
        >
          <ImportProducts
            importPSkuUnique={this.importStock}
            isLoading={this.props.isImporting}
            closeModal={() => this.onCloseModal()}
            success={
              this.props.isImportCompleted && this.props.success
                ? this.props.success
                : ""
            }
            error={this.state.importError}
            success={this.state.importSuccess}
            pSkuOpen
            exportPSku={exportPSku}
            importsType={importsType}
          />
        </Modal>
      </div>
    );
  }
}
export default PreviewStock;



// WEBPACK FOOTER //
// ./src/components/imports/PreviewStock.js